import { connect } from 'react-redux'

import { createLoadingSelector } from '../../redux/loading/loading.selectors'
import { createErrorMessageSelector } from '../../redux/error/error.selectors'


import WithSpinner from '../with-spinner/with-spinner.component'
import Error from './error.component'

const errorSelector = createErrorMessageSelector(['FETCH_TRANSACTION', 'FETCH_USER', 'FETCH_USER_INFO','FETCH_SIGNATURE_DETAILS', 'SEND_TO_ESIGNER','SEND_TO_EMBEDDING_API', 'FETCH_PDF_REPORT', 'VALIDATE_DOCUMENT'])
const loadingSelector = createLoadingSelector(['FETCH_TRANSACTION', 'FETCH_USER','FETCH_SIGNATURE_DETAILS','SEND_TO_ESIGNER','SEND_TO_EMBEDDING_API','FETCH_PDF_REPORT'])

const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  error: errorSelector(state),
  data: state.transaction.data
})

const ErrorContainer = connect(mapStateToProps)(WithSpinner(Error))

export default ErrorContainer